import { render, staticRenderFns } from "./page401.vue?vue&type=template&id=9604d9f6&scoped=true"
import script from "./page401.vue?vue&type=script&lang=js"
export * from "./page401.vue?vue&type=script&lang=js"
import style0 from "./page401.vue?vue&type=style&index=0&id=9604d9f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9604d9f6",
  null
  
)

export default component.exports